import { PRIMITIVE_PRESENTATION_DEFAULTS } from '@/adapters/primitive/_data/config/fragments/_@shared/presentationDefaults';
import type { SettlementPreviewConfig } from '@/adapters/primitive/_contract/config';

export const SETTLEMENT_PREVIEW = {
    visible: true,
    sequencingMode: 'parallel',
    resolveDurationMs: 600,
    slotDurationMs: 180,
    wall: {
        visible: true,
        groupingMode: 'per-power',
        color: PRIMITIVE_PRESENTATION_DEFAULTS.colors.base.placeholder.outline,
        innerOpacity: 0.08,
        outerOpacity: 0.12,
        cameraFade: { nearDistance: 1.5, farDistance: 6, nearOpacity: 0.3, insideOpacity: 0.5 },
    },
} as const satisfies SettlementPreviewConfig;
